import { reemplazarUrl } from "helpers/functions";
import { titulosApi } from "../view/titulos.service";
import { enqueueSnackbar } from "notistack";
import { showErrorMessages } from "../../../../hooks/useRedirectForm";

export const createTitulo = titulosApi.injectEndpoints({
  endpoints: (builder) => ({
    createTitulo: builder.mutation({
      query: (data) => {
        const { estudiante, ...rest } = data;
        const newURLv1 = reemplazarUrl(estudiante, 1);
        const finalObject = { estudiante: newURLv1, ...rest };
        return {
          url: "/v1/api/titulo/",
          method: "POST",
          body: finalObject,
        };
      },
      invalidatesTags: [{ type: "Titulos", id: "LIST" }],
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
          enqueueSnackbar("Se creó correctamente el título", {
            variant: "success",
          });
        } catch (error) {
          showErrorMessages(error.error, enqueueSnackbar);
        }
      },
    }),
  }),
});

export const { useCreateTituloMutation } = createTitulo;
